<template>
  <div class="flex flex-col">
    <slot name="prefix"></slot>
    <a-table :row-selection="{
      selectedRowKeys: selectedRowKeys,
      onChange: onSelectChange,
    }" :columns="columns" :data-source="data" :rowKey="rowKey" :pagination="false">
      <template v-for="column in columnsWithSlot" v-slot:[column.dataIndex]="txt, record">
        <slot :name="column.dataIndex" :record="record">
          <span :key="column.dataIndex">
            {{ record[column.dataIndex] }}
          </span>
        </slot>
      </template>
    </a-table>
    <div class="flex !mt-[24px] !ml-auto items-center">
      <span class="mr-5">共{{total || data.length}}条</span>
      <a-pagination v-if="isShowPagination" v-model="currentPage" show-size-changer
         :page-size="pageSize" :total="total" @showSizeChange="onPageChange" @change="onPageChange" />
    </div>
    <slot name="suffix"></slot>
  </div>
</template>

<script>
export default {
  name: "y-table",
  props: {
    url: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    extraParams: {
      type: Object,
      default() {
        return {};
      },
    },
    autoUpdateData: {
      type: Boolean,
      default: true,
    },
    resolveData: {
      type: Function,
      default() {
        return function (data) {
          return data;
        };
      },
    },
    isShowPagination: {
      type: Boolean,
      default: true,
    },
    rowKey: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      data: [],
      selectedRowKeys: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    columnsWithSlot({ columns }) {
      return columns.filter(({ scopedSlots }) => {
        return scopedSlots?.customRender;
      });
    },
  },
  watch: {
    pageSize(val) {
      console.log("pageSize", val);
    },
    currentPage(val) {
      console.log("currentPage", val);
    },
  },
  methods: {
    stringify(o) {
      return JSON.stringify(o)
    },
    async getData() {
      const [err, result] = await this.$promiseFlat(this.fetchSource());
      if (err) {
        this.$emit("error", err);
        return;
      }
      const resolvedData = await this.resolveData(result);
      console.log('resolvedData', resolvedData, result)
      this.data = resolvedData;
      this.total = result.total;
    },
    async fetchSource() {
      const { url, extraParams } = this;
      if (!url) {
        return;
      }
      const { pageSize, currentPage } = this;
      return this.$request({
        url,
        params: {
          ...extraParams,
          pageSize,
          pageNum: currentPage,
        },
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onPageChange(page, pageSize) {
      this.currentPage = page;
      this.pageSize = pageSize;
      this.getData()
    }
  },
};
</script>
